import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Создание корневого элемента React и рендер приложения
createRoot(document.getElementById("root")!).render(<App />);
